var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.402 5.428c.188-.57 1.008-.57 1.195 0l3.33 10.153a.627.627 0 00.598.428l10.845-.023c.61-.001.863.767.369 1.118l-8.787 6.252a.612.612 0 00-.23.692l3.374 10.14c.19.57-.474 1.044-.966.69l-8.76-6.29a.636.636 0 00-.74 0l-8.76 6.29c-.492.354-1.156-.12-.966-.69l3.373-10.14a.612.612 0 00-.228-.692L4.26 17.104c-.494-.351-.24-1.12.37-1.118l10.844.023a.627.627 0 00.599-.428l3.328-10.153z",
    stroke: "#000",
    strokeWidth: 1.5
  })));
}
export default SvgStar;